import { ReactNode } from 'react';
import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { DefaultViewConfig } from '../types';
import { DefaultViewContent } from './default-view-content';
import { DefaultViewFooter } from './default-view-footer';
import { DefaultViewHeader } from './default-view-header';

interface Props {
  children?: ReactNode;
  defaultViewConfig?: DefaultViewConfig;
  onAction?: () => void;
  onCancel?: () => void;
}

export const DefaultView = ({ children, defaultViewConfig, onAction, onCancel }: Props) => {
  if (!children && !defaultViewConfig) {
    return null;
  }

  if (children) {
    return <div css={containerStyles}>{children}</div>;
  }

  return (
    <div css={containerStyles}>
      <DefaultViewHeader onClose={() => onCancel?.()} />
      <DefaultViewContent>{defaultViewConfig?.content}</DefaultViewContent>
      <DefaultViewFooter
        primaryButtonLabel={defaultViewConfig?.primaryButtonLabel || ''}
        primaryButtonTrackingId={defaultViewConfig?.primaryButtonTrackingId}
        cancelButtonTrackingId={defaultViewConfig?.cancelButtonTrackingId}
        onAction={onAction}
        onCancel={onCancel}
      />
    </div>
  );
};

export const ListBoxDefaultView = Object.assign(DefaultView, {
  Header: DefaultViewHeader,
  Content: DefaultViewContent,
  Footer: DefaultViewFooter,
});

const containerStyles = css({
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: theme.colors.white,
  borderRadius: theme.borderRadius.large,
  boxShadow: theme.shadows.floating,

  // @TODO: Revisit these dimensions as per design
  minWidth: 356,
  maxWidth: 356,
});
